<!--CC: taken from powershell-integration.component.html, redesigned for onboarding wizard-->

<!--CC: before connection-->
<div class="flex-column align-items-center gap-4" style="padding-top: 60px;"
	 *ngIf="planInfo && !connected">

	<div class="flex-column align-items-center gap-3 border border-2 rounded p-5 animated fadeIn" style="max-width: 460px;">
		<i class="far fa-terminal text-primary" style="font-size: 40px;"></i>
		<span class="fw-bold" style="font-size: 1.1rem;">Connect to Exchange PowerShell</span>
		<span class="text-muted text-center lh-base" style="font-size: 0.9rem;">
			Log in with your Exchange global admin credentials to create a PowerShell integration with {{gs.corpname}}.
		</span>
		<btn-c style="margin-top: 8px;"
			   endIcon="far fa-plug"
			   [loading]="connectInProcess"
			   (action)="connectToPowershell();">
			Connect
		</btn-c>
	</div>
</div>

<!--CC: after connection-->
<div class="flex-column gap-4 animated fadeIn" *ngIf="planInfo && connected">

	<!--CC: success banner-->
	<div class="flex-row align-items-center gap-3 p-3 rounded" style="background: rgba(25, 135, 84, 0.08);">
		<i class="far fa-check-circle text-success" style="font-size: 1.5rem;"></i>
		<div class="flex-column gap-1">
			<span class="fw-bold text-success">Connected to Exchange PowerShell</span>
			<span class="text-muted" style="font-size: 0.85rem;">You are now logged in to Exchange Server PowerShell.</span>
		</div>
	</div>

	<!--CC: Set Exchange Connector & Rules button-->
	<div class="flex-column gap-3 border rounded p-3">
		<div class="flex-row align-items-center justify-content-between">
			<div class="flex-column gap-1">
				<span class="fw-bold">Set {{pageOrigin === 'inbound' ? 'Inbound' : 'Outbound'}} Exchange Connector & Rules</span>
				<span class="text-muted" style="font-size: 0.85rem;">Set up connectors and rules in Exchange to integrate your mail flow with {{gs.corpname}}.</span>
			</div>
			<btn-c endIcon="far fa-magic"
				   [loading]="rulesInProcess"
				   (action)="openSetRules();">
				Configure
			</btn-c>
		</div>
	</div>

	<!--CC: taken from powershell-integration.component.html -> Disable Exchange Protection (inbound only)-->
	<div class="flex-column gap-3 border rounded p-3" *ngIf="pageOrigin === 'inbound'">
		<div class="flex-row align-items-center justify-content-between">
			<div class="flex-column gap-1">
				<span class="fw-bold">Disable Exchange Protection</span>
				<span class="text-muted" style="font-size: 0.85rem;">Disable the default security policies in Exchange.</span>
			</div>
			<btn-c endIcon="far fa-times-circle"
				   [loading]="protectionInProcess"
				   (action)="openDisableProtection();">
				Configure
			</btn-c>
		</div>
	</div>

</div>

<!--CC: loading state-->
<div class="flex-column align-items-center justify-content-center" style="padding-top: 80px;" *ngIf="!planInfo">
	<loader></loader>
</div>

<!--CC: taken from powershell-integration.component.html -> exchange login wizard popup-->
<exchange-login-wizard-c
	*ngIf="exchangePowershellPopup[exchangePowershellCommands.login]?.show"
	[planInfo]="planInfo"
	(closePopupFn)="closeExchangePowershellPopup(exchangePowershellCommands.login, $event.success, $event.disconnected)">
</exchange-login-wizard-c>

<!--CC: taken from powershell-integration.component.html -> exchange rules wizard popup-->
<exchange-rules-wizard-c
	*ngIf="exchangePowershellPopup[exchangePowershellCommands.rules]?.show"
	(closePopupFn)="closeExchangePowershellPopup(exchangePowershellCommands.rules, $event.success, $event.disconnected)"
	[domains]="exchangePowershellPopup[exchangePowershellCommands.rules]?.domains"
	[outboundRelayArchitecture]="planInfo?.outbound_relay?.sending_architecture || false"
	[isInboundConfiguration]="pageOrigin === 'inbound'"
	[useRegion]="planInfo?.use_region">
</exchange-rules-wizard-c>

<!--CC: taken from powershell-integration.component.html -> disable exchange protection wizard popup-->
<exchange-protection-wizard-c
	*ngIf="exchangePowershellPopup[exchangePowershellCommands.protection]?.show"
	(closePopupFn)="closeExchangePowershellPopup(exchangePowershellCommands.protection, $event.success, $event.disconnected)">
</exchange-protection-wizard-c>
